import Vue from 'vue'
import Router from 'vue-router'
import ProductsPage from '@/components/page-products'
import ProductsListPage from '@/components/page-products-list'
import ProductsUploadPage from '@/components/page-products-upload'
import InventoryPage from '@/components/page-inventory'
import InventoryDetailsPage from '@/components/page-inventory-details'
import InventoryUploadPage from '@/components/page-inventory-upload'
import InventoryListPage from '@/components/page-inventory-list'
import LoginPage from '@/components/page-login'
import SettingsPage from '@/components/page-settings'
import DiscountPage from '@/components/page-discount'
import ReportPage from '@/components/page-report'
import DiscountProductPage from '@/components/app-discount-products'
import DiscountAddProductPage from '@/components/app-discount-addproduct'
import OrderItemsPage from '@/components/page-order-items'
import OrderHistoryPage from '@/components/page-order-history'
import UserPage from '@/components/page-users'
import store from '../store'
import DashboardTemplate from '@/components/template-dashboard'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: LoginPage
    },
    {
      path: '/',
      redirect: '/orders',
      component: DashboardTemplate,
      children: [
        {
          path: 'orders',
          name: 'orders',
          component: OrderItemsPage
        },
        {
          path: 'order-history',
          name: 'order-history',
          component: OrderHistoryPage
        },
        {
          path: 'order-history/:referenceNumber',
          name: 'orderHistoryByReference',
          component: OrderHistoryPage
        },
        {
          path: 'orders/:referenceNumber',
          name: 'orderByReference',
          component: OrderItemsPage
        },
        {
          path: 'products',
          alias: '/',
          component: ProductsPage,
          children: [{
            path: '/',
            name: 'products-list',
            component: ProductsListPage
          }, {
            path: 'upload',
            name: 'products-upload',
            component: ProductsUploadPage
          }]
        },
        {
          path: 'inventories',
          component: InventoryPage,
          children: [{
            path: '/',
            name: 'inventory-list',
            component: InventoryListPage
          }, {
            path: ':inventoryName',
            name: 'inventory-details',
            component: InventoryDetailsPage
          }, {
            path: ':inventoryName/upload',
            name: 'inventory-upload',
            component: InventoryUploadPage
          }]
        },
        // {
        //   path: 'shops',
        //   component: ShopsPage,
        //   children: [{
        //     path: '/',
        //     name: 'shop-list',
        //     component: ShopsListPage
        //   }, {
        //     path: ':shopCode',
        //     name: 'shop-details',
        //     component: ShopDetailsPage
        //   }]
        // },
        {
          path: 'settings',
          name: 'settings',
          component: SettingsPage
        },
        {
          path: 'discount',
          name: 'discount',
          component: DiscountPage
        },
        {
          path: 'discountlist',
          name: 'discount-list',
          component: DiscountProductPage
        },
        {
          path: 'add-discount-product',
          name: 'add-discount-product',
          component: DiscountAddProductPage
        },
        {
          path: 'report',
          name: 'report',
          component: ReportPage
        },
        {
          path: 'user',
          name: 'user',
          component: UserPage
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (!store.state.auth.user && to.name !== 'login') {
    next({name: 'login'})
  } else if (store.state.auth.user && to.name === 'login') {
    next({ name: 'orders' })
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js